module.exports = __webpack_public_path__ + "img/instruction_icon.51727774.svg";